<template>
  <section
    id="about"
    class="co-container-lg px-4 pt-10 md:pb-16 md:pt-20 md:text-center"
  >
    <h2 class="co-heading-2-caption">
      コース紹介
    </h2>
    <div class="te-index-caption mb-1 text-left sm:text-center">
      <!-- 202512月閉じ対応 -->
      <!-- <p class="co-display-9 mb-4 text-center font-bold">
        <span class="block">初めてでも実践レベルへ</span>
        <span>最短4週間で現役プロと学べる</span>
        <span class="block sm:inline-block">コースをご紹介</span>
      </p> -->
      <!-- <p class="mb-4">
        各コースのページでは、以下のようなよくある疑問にもお答えしています。ぜひコース選びにお役立てください。
      </p> -->
      <p class="mb-4">
        お申し込みを停止しております。 再開の際には改めてご案内いたします。
      </p>

      <!-- 開閉パネル -->
      <div class="collapse collapse-arrow">
        <input type="checkbox">
        <div class="co-display-14 collapse-title py-2 pr-10 text-right text-co-gray-500 md:mx-auto md:w-fit">
          よくある疑問を見る
        </div>
        <div class="collapse-content">
          <ul class="te-index-caption list-disc text-left md:mx-auto md:w-fit">
            <li>未経験だけど初心者でも学べるコース？</li>
            <li>実際にどんなものを作れるの？</li>
            <li>受講したらどんな職業が目指せるの？</li>
            <li>どんな仕事やプロジェクトに関われるの？</li>
          </ul>
        </div>
      </div>
    </div>
  </section>
</template>


<style scoped>
.te-index-caption {
  font-size: .75rem;
  @media (min-width: 768px) {
    font-size: 1rem;
  }
}

.collapse-title,
:where(.collapse > input[type="checkbox"]) {
  @apply min-h-fit;
}

.collapse-arrow > .collapse-title::after {
  @apply top-[1.125rem];
}
</style>
